import React from "react";
import { Box, ButtonGroup } from "@material-ui/core";
import { DetailButton } from "../../../../Components/DetailButton";
import { SourceAarStorage } from "./Constant/Source";
import { DeleteWithConfirmButton } from "react-admin";

export const Actions = props => {
  return (
    <Box style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "8px" }}>
      <ButtonGroup variant="text" size="small">
        <DetailButton resource={SourceAarStorage} {...props} />
        <DeleteWithConfirmButton
          {...props}
          resource={SourceAarStorage}
          confirmContent="Do you want to delete this record?"
          confirmTitle="Delete Record"
          label=""
        />
      </ButtonGroup>
    </Box>
  );
};
export default Actions;
